/**
 * A NAME FOR A LEAGUE THE PLAYER DID NOT NAME — D-EZ-103.
 *
 * The league used to be "RASCAL" unless renamed on the Career tab. Now the name
 * is asked for up front, and a blank answer gets a generated one shown in the
 * field before the player commits — never a silent default.
 *
 * Deterministic in the number it is given, so the suggestion on screen is the
 * name the league is created with. Plain stock-car flavour; no real series
 * names.
 */

const REGIONS = [
  'Blue Ridge', 'Gulf Coast', 'Piedmont', 'Tidewater', 'Ozark', 'Cumberland', 'Tri-County', 'Panhandle',
  'Lowcountry', 'Big Sky', 'Bayou', 'High Plains', 'Lakeshore', 'Red Clay', 'Delta', 'Smoky Mountain',
  'Sandhills', 'Golden Isles', 'Mid-South', 'Prairie',
] as const;

const NOUNS = [
  'Stock Car League', 'Racing Association', 'Cup Series', 'Speedway Series', 'Late Model League',
  'Motor Racing Club', 'Stock Car Circuit', 'Grand National League',
] as const;

/** A league name from a number. Same number, same name. */
export function suggestLeagueName(n: number): string {
  const x = Math.abs(Math.trunc(n)) >>> 0;
  // Two cheap mixes so neighbouring numbers do not walk the lists in step.
  const a = Math.imul(x ^ 0x9e3779b9, 0x85ebca6b) >>> 0;
  const b = Math.imul((x >>> 3) ^ 0xc2b2ae35, 0x27d4eb2f) >>> 0;
  return `${REGIONS[a % REGIONS.length]} ${NOUNS[b % NOUNS.length]}`;
}

/** The name a league is created with: what was typed, or the suggestion. */
export function leagueNameOrSuggestion(typed: string, suggestion: string): string {
  const t = typed.trim().replace(/\s+/g, ' ');
  return t.length > 0 ? t.slice(0, 40) : suggestion;
}
